import { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import {Stack, Box, Cluster, Flex} from '../../shared/layouts';
import Card from '../../shared/Card';
import Header from '../../shared/Header';
import Button from '../../shared/Button';
import Modal from "../../shared/Modal";
import QRCode from "react-qr-code";
import ReloadSvg from 'imagesUwKluis/svg/reload.svg';
import {useTranslation} from "react-i18next";
import {useMediaQuery} from "@dnhb/node_package";
import {useTheme} from '@emotion/react';
import DownloadAppModal, {
    AppleIcon,
    ClickableDownloadIcons,
    GoogleIcon
} from "../../shared/DownloadAppModal";
import WhiteLabelContext from "../../../context/WhiteLabelContext";
import useIconLibrary from "../../../hooks/useIconLibrary";

const getDeeplinkUrl = (qrCodeData) => `uwkluis://deepLogin?code=${encodeURIComponent(btoa(JSON.stringify(qrCodeData)))}`

const ScanToLoginModal = ({qrCodeData, showConnectModal, setShowConnectModal}) => {
    const qrCodeValue = JSON.stringify(qrCodeData);
    const {t} = useTranslation();
    const {breakpoints} = useTheme();

  const isMobile = useMediaQuery(`(max-width: ${breakpoints.md ?? '604px'})`);
    return (
        <Modal
            isOpen={showConnectModal}
            onRequestClose={() => setShowConnectModal(false)}
            minWidth="554px"
        >
            <Stack
                alignItems="center"
                space="l"
                css={(theme) => ({marginTop: theme.space.xl})}
            >
                {!qrCodeData ? <ReloadSvg height="240px" width="240px"/> : <QRCode value={qrCodeValue}/>}

                <Box fontScale="xl" fontWeight="bold">
                    {t('Scan de code')}
                </Box>

                {isMobile && (
                  <Flex justifyContent={'center'} width={'100%'}>
                    <a
                      href={getDeeplinkUrl(qrCodeData)}
                      target={'_blank'}
                      rel="noreferrer"
                    >
                      <Button variant={'primary-outline'} buttonSize={'small'}>
                        {t('Open met de app')}
                      </Button>
                    </a>
                  </Flex>
                )}
                <Box textAlign="center">
                    {t('Scan de QR-code met de app op je smartphone om te koppelen met jouw omgeving.')}
                </Box>
            </Stack>
            <Cluster mt="xl" display="flex" justifyContent="flex-end" hGap="m">
                <Button onClick={() => setShowConnectModal(false)}>{t('Sluiten')}</Button>
            </Cluster>
        </Modal>
    )
}

const ScanToLoginUwkluisApp = () => {
    const [showConnectModal, setShowConnectModal] = useState(false);
    const [qrCodeData, setQRCodeData] = useState(null);
    const {t} = useTranslation();
    const [showDownloadAppModal, setShowDownloadAppModal] = useState(false);
    const {appSettings} = useContext(WhiteLabelContext);
    const { LinkIcon } = useIconLibrary();

    const play_store_link = `play.google.com/store/apps/details?id=${appSettings?.packageName ?? 'nl.hypotheekbond.uwkluis'}`

    const [appInfo, setAppInfo] = useState({
      app_name: '',
      play_store_link,
      app_store_link: `apps.apple.com/us/app/id${appSettings?.iosAppStoreId ?? '1514336999'}`,
      referrer: ''
    });

    const {breakpoints} = useTheme();

    const isMobile = useMediaQuery(`(max-width: ${breakpoints.md ?? '604px'})`);


    useEffect(() => {
        if (showConnectModal || isMobile) {
            axios.get('/single-sign-on/consumer/create').then((r) => setQRCodeData(r.data))
        }
    }, [showConnectModal, isMobile])

    useEffect(() => {
      if (isMobile) {
        const referrer = `uwkluis-referrer-${encodeURIComponent(btoa(JSON.stringify(qrCodeData)))}`;

        setAppInfo({
          ...appInfo,
          play_store_link: `${play_store_link}&referrer=${referrer}`,
          referrer
        })
      }
    }, [isMobile, qrCodeData]);

    return (
        <Card>
            <ScanToLoginModal qrCodeData={qrCodeData} showConnectModal={showConnectModal}
                              setShowConnectModal={setShowConnectModal}/>
            <DownloadAppModal setShowDownloadAppModal={setShowDownloadAppModal}
                              showDownloadAppModal={showDownloadAppModal} appInfo={appInfo}/>
            <Stack space="m" width="100%">
                <Header
                    title={t('App koppelen')}
                    icon={<LinkIcon height="2rem" width="2rem"/>}
                    variant="section"
                />

                <Box>
                    {
                      isMobile
                        ? t('Download eerst de app. Om te koppelen met jouw omgeving druk op \'Open met de app knop\'.')
                        : t('Scan de QR-code met de app om te koppelen met jouw omgeving.')
                    }
                </Box>

                <Cluster mt="xl" display="flex" hGap="m">
                    <div style={{display: 'flex-row'}}>
                        <div style={{display: 'flex-row'}}>
                            {!isMobile ? (
                                <>
                                    <div
                                        style={{
                                            display: 'inline-block',
                                            overflow: 'visible',
                                            cursor: 'pointer'
                                        }}
                                    >
                                        <GoogleIcon onClick={() => setShowDownloadAppModal(true)}/>
                                    </div>
                                    <div
                                        style={{
                                            display: 'inline-block',
                                            overflow: 'hidden',
                                            cursor: 'pointer'
                                        }}
                                    >
                                        <AppleIcon onClick={() => setShowDownloadAppModal(true)}/>
                                    </div>
                                </>
                            ) : (
                                <ClickableDownloadIcons appInfo={appInfo}/>
                            )}
                        </div>

                    </div>
                </Cluster>

                <Cluster
                    mt="xl"
                    display="flex"
                    maxWidth="100%"
                    justifyContent="flex-end"
                    hGap="m"
                >
                    {isMobile && (
                        <Flex justifyContent={'center'} width={'100%'}>
                            <a
                                href={getDeeplinkUrl(qrCodeData)}
                                target={'_blank'}
                                rel="noreferrer"
                            >
                                <Button buttonSize={'small'}>
                                    {t('Open met de app')}
                                </Button>
                            </a>
                        </Flex>
                    ) ||  <Button onClick={() => setShowConnectModal(true)}>
                        {t('Koppelen')}
                    </Button>}

                </Cluster>

            </Stack>
        </Card>
    );
};

export default ScanToLoginUwkluisApp;
